import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
import RouteIndex from './routers/routes/index';
import {
  basePalette,
  baseButtonHoverStyle,
  baseMenuItemStyle,
  baseRadioStyle,
  baseSwitchStyle,
  baseTypography,
} from './constants/location';

const theme = createTheme({
  // トグルはブランドのオレンジ、プルダウンの項目はグレーで統一する（#3075）
  // ボタン・アイコンボタンの既定ホバーもグレーに戻す（#3310）
  // 計算フィールドで disabled にしたラジオも選択色を残す（#3358）
  components: {
    ...baseSwitchStyle,
    ...baseRadioStyle,
    ...baseMenuItemStyle,
    ...baseButtonHoverStyle,
  },
  palette: basePalette,
  typography: baseTypography,
});

const App = (): React.ReactElement => (
  <ThemeProvider theme={theme}>
    <div className="App">
      <RouteIndex />
    </div>
  </ThemeProvider>
);

export default App;
